import React, { useEffect, useRef, useState } from "react";
import Modal from 'react-bootstrap/Modal';

import '../../css/modal.css';
import Attention from "../ReusableComponents/Attention";
import { Form, FormControl as Input, InputGroup, Button, Select, Spinner } from "react-bootstrap";
import DefaultButton from "../ReusableComponents/DefaultButton";
import { RiCloseFill } from "react-icons/ri";
import { MdDelete } from "react-icons/md";
import { usePreferences } from "../../contexts/PreferencesContext";
import TableEmptyState from '../ReusableComponents/TableEmptyState';

const ModalCorretor = (props) => {const { t } = usePreferences();
  const { processo_name, showModal, setShowModal, corretor, salas_all, OnFinish, redacoes } = props;
  const [salas_selecionadas, setSalasSelecionadas] = useState({});
  const [selectSala, setSelectSala] = useState('');
  const [salas_total, setSalasTotal] = useState({});


  useEffect(() => {
    if (corretor != null && corretor.salas != undefined) {
      let salas_selecionadas_ = {};
      for (let i = 0; i < corretor.salas.length; i++) {
        salas_selecionadas_[corretor.salas[i].id] = corretor.salas[i];
      }
      setSalasSelecionadas(salas_selecionadas_);
    }
  }, [corretor]);

  useEffect(() => {
    let salas_total_ = {};
    for (let i = 0; i < salas_all.length; i++) {
      salas_total_[salas_all[i].id] = salas_all[i];
    }
    setSalasTotal(salas_total_);

  }, []);

  console.log(salas_total);

  return (
    corretor != null && <Modal
      show={showModal == true}
      dialogClassName="modal_width"
      onHide={() => {
        setShowModal(false);
        setSalasSelecionadas({});
      }}>

            <Modal.Header closeButton closeLabel=''><Modal.Title>{`${t("legacy_corretor")} `}{corretor.name}<br /></Modal.Title></Modal.Header>
            <Modal.Body>
                <InputGroup>
                    <div className="flex fdcolumn flex1 margin-bottom">
                        <Form.Label>{`${t("rooms")} `}<Attention /></Form.Label>
                        <select className="form-select " onChange={(e) => {
              if (e.target.value != '') {
                let salas_selecionadas_ = { ...salas_selecionadas };
                let salas = { ...salas_total };
                delete salas[e.target.value];
                salas_selecionadas_[e.target.value] = { ...salas_total[e.target.value] };
                salas_selecionadas_[e.target.value].redacao = 'all';
                salas_selecionadas_[e.target.value].redacao_name = t("option_all_feminine");

                setSalasSelecionadas(salas_selecionadas_);
                setSalasTotal(salas);
              }
            }} value={selectSala}>
                            <option value="">{t("placeholder_select_one_or_more_rooms")}</option>
                            {Object.values(salas_total).sort((a, b) => a.created_at - b.created_at).map((value, index) =>
              <option
                key={index}
                value={value["id"]}>{`${t("legacy_sala")} `}
                {value["numero"]} - {t("legacy_presentes")}: {value.presentes} - {t("label_total")}: {value.candidatos}</option>
              )}
                        </select>

                    </div>
                </InputGroup>

                <InputGroup>

                    <div className="flex fdcolumn flex1 margin-bottom">
                        <div className="table-modern-card">
                            <div className="table-modern-scroll">
                                <table id="tech-companies-1" className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>{t("legacy_sala")}</th>
                                            <th>{t("legacy_presentes")}</th>
                                            <th>{t("legacy_total")}</th>
                                            <th>{t("ui_corrigira_quais_redacoes_9a93a9ff")}</th>
                                            <th data-priority="3">{t("label_actions")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.values(salas_selecionadas).sort((a, b) => a.created_at - b.created_at).map((item, id) =>
                    <tr key={id}>
                                                <td>{`${t("legacy_sala")} `}{item.numero}</td>
                                                <td>{item.presentes}</td>
                                                <td>{item.candidatos}</td>
                                                <td>
                                                    <select className="form-select " onChange={(e) => {
                          if (e.target.value != '') {
                            let salas_selecionadas_ = { ...salas_selecionadas };
                            console.log(e.target.value);
                            console.log({ ...item });
                            console.log({ ...salas_selecionadas_ });
                            salas_selecionadas_[item.id].redacao = e.target.value;
                            salas_selecionadas_[item.id].redacao_name = e.target.value == 'all' ? t("option_all_feminine") : redacoes.filter((item2) => item2.id == e.target.value)[0].name;

                            setSalasSelecionadas(salas_selecionadas_);
                          }
                        }} value={salas_selecionadas[item.id].redacao}>
                                                        <option value="all">{t("option_all_feminine")}</option>
                                                        {redacoes.map((value, index) =>
                          <option
                            key={index}
                            value={value["id"]}>
                            {value['name']}</option>
                          )}
                                                    </select>
                                                </td>

                                                <td>
                                                    <div className="actions-group">
                                                    <span
                          onClick={(e) => {
                            let salas = { ...salas_total };
                            salas[item.id] = { ...salas_selecionadas[item.id] };

                            let salas_selecionadas_ = { ...salas_selecionadas };
                            delete salas_selecionadas_[item.id];

                            setSalasSelecionadas(salas_selecionadas_);
                            setSalasTotal(salas);

                          }}
                          className="inline-flex align-center jcc bg-danger icon"
                          style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                          title={t("action_delete_room")}>

                                                        <MdDelete size={17} color="white" />
                                                    </span>

                                                    </div>
                                                    </td>

                                            </tr>
                    )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {Object.values(salas_selecionadas).length == 0 && <div className="row">
                            <div className="col-12">
                                <TableEmptyState title={t("ui_nenhuma_sala_selecionada_bf0df991")} icon="📋" />

                            </div>
                        </div>}
                    </div>

                </InputGroup>


                {<div className="w100 inline-flex jcsb margin-top-1">
                    {/* <Link to={`/accounts/list`}>
            <Button variant="secondary"><RiArrowGoBackLine/> Voltar</Button>
            </Link> */}
                    <DefaultButton
            bg="secondary"
            text={t("action_close")}
            icon={<RiCloseFill />}
            onClick={() => {
              setShowModal(false);
              setSalasSelecionadas({});
            }} />

                    {/* <Button variant="success" type="submit" disabled={this.loading}>
            {this.state.loading ? <Spinner /> : ""}
            Registrar usuário
            </Button> */}
                    <DefaultButton
            type="button"
            disabled={Object.values(salas_selecionadas).length == 0}
            onClick={() => {
              OnFinish(Object.values({ ...salas_selecionadas }).sort((a, b) => a.created_at - b.created_at), corretor);
              setShowModal(false);

              setSalasSelecionadas({});


            }}
            bg={Object.values(salas_selecionadas).length > 0 ? "confirm" : "secondary"}
            text={t("action_save")} />

                </div>}

            </Modal.Body>
        </Modal>);


};

export default ModalCorretor;
